import React from "react";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";

function MenuItems(props) {
  let backgroundC = undefined;
  let borderC = undefined;
  if (props.variant === undefined) {
    backgroundC = props.backgroundC;
    borderC = props.backgroundC;
  }

  if (props.borderC != undefined) {
    borderC = props.borderC;
  } 

  let widthOfObj = props.width
  if(widthOfObj == undefined){
    widthOfObj = '100%'
  }
  return (
    <Link style={{ color: "white", textDecoration: "none" }} to={props.url}>
      <Button
        size="lg"
        variant={props.variant}
        style={{
          height: "120px",
          width: widthOfObj,
          boxShadow: "rgba(0, 0, 0, 0.39)3px 3px 1px 0px",
          background: backgroundC,
          color: props.fontColor,
          border: borderC,
          marginBottom: "5px",
          marginRight: "5px",
        }}
        id={props.itemkey + '-' + props.difficulty}
      >
        <h4>
          <b style={{ fontSize: props.fontSize }}>{props.title}</b>
        </h4>
      </Button>
    </Link>
  );
}

export default MenuItems;
